import { useTranslation } from "react-i18next"
import { Button } from "../App.styles"
import { Spinner } from "../common"
import { Typography } from "@material-ui/core"
import EmptyPage from "../common/EmptyPage"
import { ReactComponent as EmptyGroup } from "../images/empty-groups.svg"

const GroupsEmpty = ({ isCreating, onCreate }) => {
    const { t } = useTranslation()

    return (
        <EmptyPage>
            <EmptyGroup />
            <div>
                <Typography className="text-center mb-4">{t(`You have no groups yet`)}</Typography>
                <Button data-testid="group__add-new" size="lg" className="btn--flat btn--flat-sm d-block w-100" color="primary" onClick={onCreate} disabled={isCreating}>
                    {t('Add Group')} {isCreating && <Spinner size="0.875rem" />}
                </Button>
            </div>
        </EmptyPage>
    )
}

export default GroupsEmpty
